<template>
  <el-dialog
    :title="dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="dataForm.roleName" placeholder="角色名称"></el-input>
      </el-form-item>
      <el-form-item label="角色描述" prop="remark">
        <el-input v-model="dataForm.remark" placeholder="角色描述"></el-input>
      </el-form-item>
      <el-form-item label="APP权限" prop="remark" v-if="isAuth('role:app')">
        <el-select v-model="dataForm.type" placeholder="请选择点位" style="width: 100%">
          <el-option
            v-for="item in typeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色权限">
        <el-tree
          v-if="!addTree"
          v-model="dataForm.menuIds"
          :data="menus"
          show-checkbox
          :default-checked-keys=dataForm.menuIds
          node-key="id"
          :check-strictly="true"
          :props="defaultProps"
          ref="menuTree">
        </el-tree>
        <el-tree
          v-if="addTree"
          v-model="dataForm.menuIds"
          :data="menus"
          show-checkbox
          :default-checked-keys=dataForm.menuIds
          node-key="id"
          :props="defaultProps"
          ref="menuTree">
        </el-tree>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="unSubmit()">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {isAuth} from "../../utils";

export default {
  data() {
    return {
      visible: false,
      addTree: false,
      menus: [],
      typeOption: [{value: 1, label: "启用"}, {value: 2, label: "禁用"}],
      dataForm: {
        roleId: 0,
        roleName: '',
        remark: '',
        createTime: '',
        modifyTime: '',
        companyId: '',
        type: '',
        menuIds: []
      },
      dataRule: {
        roleName: [
          {required: true, message: '角色名称不能为空', trigger: 'blur'}
        ],
        remark: [
          {required: true, message: '角色描述不能为空', trigger: 'blur'}
        ],
        createTime: [
          {required: true, message: '创建时间不能为空', trigger: 'blur'}
        ],
        modifyTime: [
          {required: true, message: '修改时间不能为空', trigger: 'blur'}
        ],
        companyId: [
          {required: true, message: '企业ID不能为空', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '不能为空', trigger: 'blur'}
        ]
      },
      defaultProps: {
        children: 'childs',
        label: 'title',
      }
    }
  },
  methods: {
    init(id) {
      this.getMenuTree()
      this.dataForm = {}
      if (id) {
        this.addTree = false
        this.dataForm.id = id
        this.$nextTick(() => {
          this.$http({
            url: this.$http.adornUrl("/role/list"),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              "roleId": id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
              this.dataForm.menuIds = data.data.rows[0].menus.split(',')
            }
          })
        })
      } else {
        this.dataForm.id = null
        this.addTree = true
      }
      this.visible = true
    },
    // 表单提交
    dataFormSubmit() {
      let menuIds = []
      //获取选中的节点
      let checkedNodes = this.$refs.menuTree.getCheckedNodes()
      for (let i = 0; i < checkedNodes.length; i++) {
        menuIds.push(checkedNodes[i].id)
      }
      //获取半选中的节点
      let halCheckNodes = this.$refs.menuTree.getHalfCheckedKeys();
      for (let i = 0; i < halCheckNodes.length; i++) {
        menuIds.push(halCheckNodes[i])
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/role/${!this.dataForm.roleId ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'roleId': this.dataForm.roleId || undefined,
              'roleName': this.dataForm.roleName,
              'remark': this.dataForm.remark,
              'type': this.dataForm.type,
              'menuIds': menuIds,
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    getMenuTree() {
      this.$http({
        url: this.$http.adornUrl("/menu/tree"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.menus = data.data.menuTree.childs
        }
      })
    },
    unSubmit() {
      this.menus = []
      this.dataForm = {}
      this.visible = false
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/role-add-or-update.vue